module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image11-77051f515449dd1714e2dd9e0496872c.jpg";